var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6249 3.487L16.3119 1.799C16.6636 1.44733 17.1406 1.24976 17.6379 1.24976C18.1353 1.24976 18.6123 1.44733 18.9639 1.799C19.3156 2.15068 19.5132 2.62766 19.5132 3.125C19.5132 3.62235 19.3156 4.09933 18.9639 4.451L8.34494 15.07C7.81626 15.5984 7.16431 15.9867 6.44794 16.2L3.76294 17L4.56294 14.315C4.77622 13.5986 5.16457 12.9467 5.69294 12.418L14.6249 3.487ZM14.6249 3.487L17.2629 6.125M15.7629 13V17.75C15.7629 18.3467 15.5259 18.919 15.1039 19.341C14.682 19.763 14.1097 20 13.5129 20H3.01294C2.4162 20 1.84391 19.763 1.42195 19.341C0.999992 18.919 0.762939 18.3467 0.762939 17.75V7.25C0.762939 6.65327 0.999992 6.08097 1.42195 5.65901C1.84391 5.23706 2.4162 5 3.01294 5H7.76294",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChatIcon);
export default __webpack_public_path__ + "static/media/NewChatIcon.be374b83bdd29a61109043019797a0cc.svg";
export { ForwardRef as ReactComponent };